import * as React from "react";
const SvgFiRrChessKingAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 18h-.394a25.3 25.3 0 0 1-2.531-8H17a1 1 0 1 0 0-2h-.392s1.092-1.682 1.107-1.723A3 3 0 0 0 15 2h-2V1a1 1 0 0 0-2 0v1H9a3 3 0 0 0-2.712 4.277C6.307 6.318 7.4 8 7.4 8H7a1 1 0 0 0 0 2h.926a25.3 25.3 0 0 1-2.532 8H5a3 3 0 0 0 0 6h14a3 3 0 0 0 0-6M8.075 5.374A1 1 0 0 1 9 4h6a1 1 0 0 1 .928 1.374L14.224 8H9.779zM9.935 10h4.13a25.8 25.8 0 0 0 2.318 8H7.617a25.8 25.8 0 0 0 2.318-8M19 22H5a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2"
    />
  </svg>
);
export default SvgFiRrChessKingAlt;
